import React, { useState, useEffect } from 'react';
import TutorWebview from './tutor/webviewreboot/App';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import StudentWebview from './student/webview/App';
import Rewards from './student/webview/Rewards';
import Banner from './student/webview/Banner';
import Scratch from './student/scratch-and-win/App';

import { GET, makeApiCal } from '.././src/tutor/webviewreboot/util';

import WebCampaigns from './tutor/web/App';
// import Home from './tutor/webview/components/Home/';
import BackgroundDisplay from './tutor/webviewreboot/components/Home/BackgroundDisplay/BackgroundDisplay';
// import Layout from './tutor/webview/components/Layout';
// import RewardsPage from './tutor/webview/components/RewardsPage';
import GrowthInsights from './tutor/webviewreboot/components/GrowthInsights';
// import EndCampaignPage from './tutor/EndCampaign';
import TopLayout from './tutor/webviewreboot/components/TopLayout/TopLayout';
import Referral from './tutor/Referral/Referral';
import FlagInt from './tutor/webviewreboot/components/FlagInt/FlagInt';
import starLeaderboardInt from './tutor/webviewreboot/components/StarLeadInt';
import { initCosmos } from './cosmosTracking';
import BillboardInt from './tutor/webviewreboot/components/BillboardInt/BillboardInt';

function App() {
	const [err, catchError] = useState(false);
	const [userApiData, setUserData] = useState();
	const [orgApiData, setOrgData] = useState();
	function isAndroid() {
		return /android/i.test(navigator.userAgent);
	}

	// Function to check if the user is on an iOS device
	function isIOS() {
		return /iphone|ipad|ipod/i.test(navigator.userAgent);
	}
	useEffect(() => {
		localStorage.setItem('deviceType', isAndroid() ? 'android' : 'ios');
		const action = {
			method: GET,
			route: 'v2/org/details',
			storeData: setOrgData,
			catchError: catchError,
		};
		makeApiCal(action);
	}, []);
	useEffect(() => {
		if (orgApiData) {
			let orgData = {
				...orgApiData,
			};
			localStorage.setItem('cpOrgCode', orgData?.organization?.code);
			localStorage.setItem('cpOrgId', orgData?.organization?.id);
			localStorage.setItem('cpOrgName', orgData.organization.name);
			localStorage.setItem('cpOrgType', orgData.organization?.buildType);
			localStorage.setItem('cpOrgData', JSON.stringify(orgData));
		}
	}, [orgApiData]);

	useEffect(() => {
		const action = {
			method: GET,
			route: 'v2/users/details',
			storeData: setUserData,
			catchError: catchError,
		};
		makeApiCal(action);
	}, []);
	useEffect(() => {
		if (userApiData) {
			let userData = {
				...userApiData,
			};
			localStorage.setItem('cpUserId', userData.responseData.user.id);
			localStorage.setItem('cpUserName', userData.responseData.user.name);
			localStorage.setItem('cpUserType', userData.responseData.user.type);
			localStorage.setItem('cpUserData', JSON.stringify(userData));
		}
	}, [userApiData]);

	initCosmos();

	return (
		<div className="App">
			<BrowserRouter>
				<Switch>
					<Route exact path="/banner" component={Banner} />
					<Route path="/student" component={Rewards} />

					<Route exact path="/scratch" component={Scratch} />

					{/* <Route exact path="/tutor" component={BackgroundDisplay} /> */}

					{/* <Route exact path="/" component={TutorWebview} /> */}

					<Route exact path={['/tutor', '/']} component={BackgroundDisplay} />
					<Route exact path="/web" component={WebCampaigns} />

					{/* <Route
  path="/dashboard"
  render={(props) => <Dashboard {...props} authed={true} />}
/> */}

					<Route
						exact
						path="/tutor/details/:tab"
						render={(props) => <TopLayout {...props} />}
					/>
					{/* <Route exact path="/tutor/rewards" component={RewardsPage} /> */}
					<Route exact path="/tutor/growth" component={GrowthInsights} />
					<Route exact path="/tutor/flag" component={FlagInt} />
					<Route exact path="/referralpage" component={Referral} />
					<Route exact path="/tutor/star" component={starLeaderboardInt} data />
					<Route
						exact
						path="/tutor/billboard"
						render={() => (
							<BillboardInt data={orgApiData?.organization?.name} />
						)}
					/>
				</Switch>
			</BrowserRouter>
		</div>
	);
}

export default App;

